import React, { useEffect, useRef } from 'react';

import styles from './Button.module.scss';

function Button(props) {
  const {
    children,
    onClick,
    primary,
    secondary,
    disabled,
    className,
    globalState,
    onMount,
    testId,
  } = props;
  const colorScheme = globalState
    ? globalState.getColorScheme()
    : { primary: '#cccccc' };

  const _className = [styles.Button];
  primary && _className.push(styles['--primary']);
  secondary && _className.push(styles['--secondary']);
  disabled && _className.push(styles['--disabled']);
  className && _className.push(className);

  let style = {};
  if (!disabled && primary)
    style = { ...style, backgroundColor: colorScheme.primary };
  if (!disabled && secondary)
    style = {
      ...style,
      color: colorScheme.primary,
      borderColor: colorScheme.primary,
    };

  function handleClick() {
    onClick && !disabled && onClick();
  }

  const buttonRef = useRef();
  useEffect(() => {
    onMount && onMount(buttonRef.current);
  }, []); // eslint-disable-line

  return (
    <div
      ref={buttonRef}
      className={_className.join(' ')}
      style={style}
      onClick={handleClick}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export default Button;
